module.exports = __webpack_public_path__ + "static/ceramic-vases-installation-at-tempeton-general-boston-bdfad04307cb32c44d728585e2616c0e.jpg";